import { useEffect, useState, useRef, useCallback } from 'react';
import { SVG } from '@svgdotjs/svg.js';

import useStore from '../../store/store';
import { HeightRuler } from './common/HeightRuler';

const FirstBarrier = () => {
	const gRef = useRef();
	const [gRulerRef, setGRulerRef] = useState({ current: undefined });
	const gParentRef = useRef();
	const barrierRef = useRef();
	const barrierHeight = useStore((state) => state.barrier1.height);
	const barrierXpos = useStore((state) => state.barrier1.distance);
	const distance = useStore((state) => state.distance);
	const getUnitFromMeter = useStore((state) => state.getUnitFromMeter);
	const getSingleUnit = useStore((state) => state.getSingleUnit);
	const singleUnit = getSingleUnit();
	const setBarrier1 = useStore((state) => state.setBarrier1);
	const getfirstBarrierInitialPosition = useStore((state) => state.getfirstBarrierInitialPosition);
	
	const onHeightChange = useCallback((newHeight) => {
		setBarrier1({ height: newHeight });
	}, []);

	useEffect(() => {
		const draw = SVG('#barriers');
		const gParent = gParentRef.current = draw.group().id('barrier1');
		const { x, y } = getfirstBarrierInitialPosition();

		const g = gRef.current = gParent?.group();
		setGRulerRef({ current: gParent.group().transform({ translateX: barrierXpos * singleUnit / 0.1 }) });
		gParent.transform({ translateX: x, translateY: y });
		barrierRef.current = g.polyline().fill('#005c56');

		const textGroup = g.group();
		textGroup.attr({ class: 'draggable' });
		textGroup.circle(14).cx(0).cy(14 / 2 - 1).fill('#005c56');
		const barrierText = textGroup.text('BARRIER').attr({ x: 5, y: -15 }).font({ anchor: 'middle', size: '12px' }).fill('#ffffff');
		const barrierTextSize = barrierText.node.getBBox();
		textGroup.rect(barrierTextSize.width + 10, barrierTextSize.height + 4)
			.transform({ translate: { x: barrierTextSize.x - 5, y: barrierTextSize.y - 2 } })
			.radius(5)
			.fill('#ef7521')
			.backward();

		let boxAtDragStart;
		textGroup.draggable()
			.on('dragstart', (e) => {
				boxAtDragStart = e.detail.box;
			})
			.on('dragmove', (e) => {
				// move while get source position + offset < receiver
				e.preventDefault();
				const { box } = e.detail;
				let yOffset = g.transform('translateY');
				let xOffset = g.transform('translateX');
				if (Math.abs(boxAtDragStart.y2 - box.y2) > 0) {
					yOffset += (box.y2 - box.y2 % singleUnit) - 24 / 2;
				}
				if (Math.abs(boxAtDragStart.x2 - box.x2) > 0) {
					xOffset += box.w / 2 + (box.x - box.x2 % singleUnit) - 5 / 2;
				}
				const xOffsetInMeters = Math.abs(xOffset * 0.1 / singleUnit).toFixed(1);
				setBarrier1({
					height: yOffset > 0 ? 0 : Math.abs(yOffset * 0.1 / singleUnit).toFixed(1),
					distance: xOffset < 0 ? 0 : (xOffsetInMeters > distance ? distance : xOffsetInMeters)
				});
			});

		return () => {
			setGRulerRef({ current: undefined });
			gParent.remove();
		};
	}, [distance]);

	useEffect(() => {
		// update line.
		if (barrierRef.current) {
			barrierRef.current.plot(`-3 0
			-3 ${getUnitFromMeter(barrierHeight)}
			3 ${getUnitFromMeter(barrierHeight)}
			3 0`);
		}
		gRef.current.transform({
			translateY: -barrierHeight * singleUnit / 0.1,
			translateX: barrierXpos * singleUnit / 0.1
		});
		gRulerRef.current && gRulerRef.current.transform({
			translateX: barrierXpos * singleUnit / 0.1
		});
	}, [singleUnit, barrierHeight, barrierXpos]);

	return (
		<>
			{!gRulerRef.current ? null : (
				<HeightRuler
					gRef={gRulerRef}
					height={barrierHeight}
					onHeightChange={onHeightChange}
				/>
			)}
		</>
	);
};

export { FirstBarrier };